module.exports = __webpack_public_path__ + "img/didi.42a55ca4.png";